import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';
import { SendCommandDto } from 'src/app/model/qModel.model';
declare var $: any;
@Component({
  selector: 'app-sync-score',
  templateUrl: './sync-score.component.html',

})

export class SyncScoreComponent implements OnInit {
  mobileDevice: any[] = []
  deviceId: any;
  deviceName: any;
  SCORE: string = 'SCORE'
  isLock: boolean;

  constructor(private _router: Router, private _Service: ApiService,
    private activatedRoute: ActivatedRoute, private _toastr: ToastrService, private location: Location) { }
  isLoading: boolean = false;
  sendCommanddto: SendCommandDto = new SendCommandDto();
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')

  })
  ngOnInit(): void {
    this.deviceId = this.activatedRoute.snapshot.params["id"];
    this.getDevicesInUser()
  }
  goBack() {
    this.location.back()
  }


  onMobileDeviceSelect(evt: any) {
    this.deviceId = evt.target.value;
    this.mobileDevice.forEach(element => {
      if (this.deviceId == element.id) {
        this.deviceName = element.name;
      }
    });
  }


  // Fetching all mobile device added from Manage Device
  //deviceName: any
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._Service.getService(this._Service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach((element: any) => {
              if (this.deviceId == element.id) {
                this.deviceName = element.deviceName;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(element.id);
              }
            });
          }
          else {
            let deviceId = response.data[0].id;
            this.restorePublishForm.controls['mobileDeviceName'].setValue(deviceId);
          }
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }



  sendCommand() {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = 'SCORE'
      this._Service.postService(this._Service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          $("#ScorePopup").modal("show");
          this.isLock = false
          this._toastr.success('', response.status.message);
        } else {
          this._toastr.error('', response.status.message);
        }
        this.isLoading = false;
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

}
